module.exports = __webpack_public_path__ + "static/media/drazenko.a780f210.jpg";